import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Box from '@mui/material/Box';
import { FilterAttributeOption } from '@checkfront/guest-experience-api-api-client-javascript-axios';
import { classes } from '@guest-widgets/shared/src/classes';

interface CheckboxListProps {
  filterValues: string[] | undefined;
  attributeOptions: FilterAttributeOption[];
  onSelect: (list: string[] | undefined) => void;
}

export const CheckboxList = ({ filterValues, attributeOptions, onSelect }: CheckboxListProps) => {
  const handleChange = (id: string, isChecked: boolean) => {
    if (isChecked) {
      return onSelect((filterValues || []).concat([id]));
    }

    const array = filterValues?.filter((str) => str !== id);

    onSelect(array?.length === 0 ? undefined : array);
  };

  if (!attributeOptions || attributeOptions.length === 0) return null;

  return (
    <>
      {attributeOptions.map(({ title, value }: FilterAttributeOption) => {
        const isChecked = filterValues?.includes(value) ?? false;
        return (
          <Box
            key={value}
            className={classes.catalog.filters.option}
            display="flex"
            flexDirection="column"
          >
            <FormControlLabel
              control={
                <Checkbox
                  color="secondary"
                  checked={isChecked}
                  onChange={(event) => handleChange(value, event.target.checked)}
                  name={title}
                />
              }
              label={title}
            />
          </Box>
        );
      })}
    </>
  );
};
